import React from 'react';
import { theme, styles } from '../constants.js';

const SmartRow = ({ mode, data, onChange, onDelete }) => {
  const deleteBtn = <button type="button" onClick={onDelete} style={{ background: 'none', border: 'none', color: '#cbd5e1', fontSize: '1.8rem', cursor: 'pointer', transition: 'color 0.2s' }} onMouseEnter={(e) => e.target.style.color = theme.danger} onMouseLeave={(e) => e.target.style.color = '#cbd5e1'}>×</button>;

  if (mode === 'INVESTIGATION') {
    return (
      <div style={{ ...styles.dynamicRow, backgroundColor: '#eef2ff', borderColor: '#c7d2fe' }}>
        <div style={{ ...styles.inputGroup, flex: 1 }}>
          <input style={styles.input} placeholder="Investigation Type (e.g., MRI, Bloods)" value={data.type || ''} onChange={(e) => onChange({ type: e.target.value })} />
        </div>
        <div style={{ ...styles.inputGroup, flex: 2 }}>
          <input type="text" style={styles.input} placeholder="Key Findings..." value={data.finding || ''} onChange={(e) => onChange({ finding: e.target.value })} />
        </div>
        {deleteBtn}
      </div>
    );
  }
  return null;
};

export default SmartRow;
